export const SOFTLINE_FEATURE_ITEM_SCAN = 'itemScan';
